import { useEffect } from 'react'
import { useSidepanelState } from '@renderer/overlay/atoms'
import { AnalyticsRenderer } from '@renderer/utils/analytics.renderer'

/**
 * Reloads PostHog flags when the sidepanel opens or closes.
 *
 * The overlay window stays visible behind the notch and rarely gains focus, so
 * the refreshes that other windows get from focus and visibility never fire
 * here. Opening or closing the panel is this window's equivalent. Other
 * renderers pick up the result through posthog-js's shared localStorage.
 */
export function useRefreshFlagsOnSidepanelToggle(): void {
  const isOpen = useSidepanelState() === 'open'

  useEffect(() => {
    AnalyticsRenderer.flags.refresh()
  }, [isOpen])
}
